import React from 'react'
import CustomSelect from 'src/components/CustomComponents/CustomSelect'

export const BOOK_LANGUAGE_TYPE_OPTIONS = [
	// { label: 'single', value: 'single' },
	{ label: 'bilingual', value: 'bilingual' },
]

const BOOK_LANGUAGE_TYPE_OPTIONS_WITH_ALL = [
	{ label: 'All', value: null },
	...BOOK_LANGUAGE_TYPE_OPTIONS,
]

interface BookLanguageTypeProps {
	includeAll?: boolean
	value: string | null
	onChange: (value: string | null) => void
	sx?: any
	placeholder?: string
}

function BookLanguageType({
	includeAll = false,
	value,
	onChange,
	sx,
	placeholder = 'Language Type',
}: BookLanguageTypeProps) {
	return (
		<CustomSelect
			value={value}
			data={includeAll ? BOOK_LANGUAGE_TYPE_OPTIONS_WITH_ALL : BOOK_LANGUAGE_TYPE_OPTIONS}
			onChange={onChange}
			placeholder={placeholder}
			sx={sx}
		/>
	)
}

export default React.memo(BookLanguageType)
